<template>
  <div class="mapCard mb-16 flex-initial">
    <!-- <div class="absolute p-8 z-10" style="top: 12px; right: 12px">
      <i @click="close" class="cursor-pointer owl-status-error text-white text-xl"></i>
    </div> -->
    <div class="option rounded-full shadow-lg cursor-pointer absolute z-10" style="padding: 4px 2px;top: 12px; right: 60px">
      <i @click.prevent="onFavoriteHandler(hotel)" class="cursor-pointer owl-rank-heart text-white text-xl" :class="{ 'text-red': isFavorite }"></i>
    </div>
    <div class="option rounded-full shadow-lg cursor-pointer absolute z-10" style="padding: 4px 2px;top: 12px; right: 12px">
      <i @click="close" class="cursor-pointer owl-status-error text-white text-xl"></i>
    </div>
    <div class="rounded-sm overflow-hidden no-underline text-grey h-full bg-white">
      <div class="coverImage flex relative overflow-hidden" style="border-radius: 20px; max-height: 200px">
        <div v-if="hotel.imageUrls.length > 1" ref="prevBtn" :class="`swiper-button-prev swiper-button-prev-${cid} option`" slot="button-prev">
          <div class="flex items-center justify-center swiper-button text-xl">
            <i class="owl-direction-left"></i>
          </div>
        </div>
        <div v-if="hotel.imageUrls.length > 1" ref="nextBtn" :class="`swiper-button-next swiper-button-next-${cid} option`" slot="button-next">
          <div class="flex items-center justify-center swiper-button text-xl">
            <i class="owl-direction-right"></i>
          </div>
        </div>
        <swiper v-if="hotel.imageUrls.length > 1" :key="hotelUuid" :options="options" :ref="`swiper-${cid}`" class="w-full h-full">
          <swiper-slide v-for="(image, index) in hotelCover" :key="`hotelCover-${index}`">
            <!-- <img :src="image" alt=""  style="height: 200px; max-height: 200px; width: 100%;"> -->
            <div class="image" v-lazy:background-image="{ src: image, error: require('@/assets/images/default-room.jpg') }" style="max-height: 200px; width: 100%;" />
          </swiper-slide>
        </swiper>
        <div v-else-if="hotel.imageUrls.length === 1" class="image" v-lazy:background-image="{ src: hotelCover[0], error: require('@/assets/images/default-room.jpg') }" alt=""  style="max-height: 200px; width: 100%;" />
        <div v-else class="image" v-lazy:background-image="require('@/assets/images/default-room.jpg')" alt=""  style="max-height: 200px; width: 100%;" />
      </div>
      <div class="hotelCard__content p-8 flex flex-col justify-between">
        <div v-if="hotel.tags && hotel.tags.length > 0" class="tags hidden md:flex items-center">
          <div v-if="hotel.tags && hotel.tags.length > 0" class="flex items-center">
            <template v-if="selectedLang === 'zh_TW' || selectedLang === 'zh_CN'">
              <div class="bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full" style="opacity: 0.8;" :key="hotel.tags[0].id">{{ hotel.tags[0].name }}</div>
              <div v-if="hotel.tags.length > 1" class="bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full" style="opacity: 0.8;" :key="hotel.tags[1].id">{{ hotel.tags[1].name }}</div>
              <div v-if="hotel.tags.length === 3" class="bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full" style="opacity: 0.8;" :key="hotel.tags[2].id">{{ hotel.tags[2].name }}</div>
              <el-tooltip v-if="hotel.tags.length > 3" effect="dark" placement="right">
                <div class="tags__more bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full" style="opacity: 0.8;">{{ hotel.tags.length - 2 }}+</div>
                <div slot="content">
                  <div v-for="(tag, index) in hotel.tags.slice(2)" :key="tag.id" :class="index === 0 ? 'mt-0' : 'mt-8'">{{ tag.name }}</div>
                </div>
              </el-tooltip>
            </template>
            <template v-else>
              <div class="bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full" style="opacity: 0.8;" :key="hotel.tags[0].id">{{ hotel.tags[0].name }}</div>
            <el-tooltip v-if="hotel.tags.length > 1" effect="dark" placement="right">
              <div class="tags__more bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full" style="opacity: 0.8;">{{ hotel.tags.length - 1 }}+</div>
              <div slot="content">
                <div v-for="(tag, index) in hotel.tags.slice(1)" :key="tag.id" :class="index === 0 ? 'mt-0' : 'mt-8'" style="opacity: 0.8;">{{ tag.name }}</div>
              </div>
            </el-tooltip>
            </template>
          </div>
          <img v-if="hotel.tripAdvisor" class="ml-4" width="100px" :src="hotel.tripAdvisor.logo" />
        </div>
        <router-link v-if="hotel.type === CARD_TYPE_HOTEL" :to="goToHotel" class="mapCard__link inline-block" target="_blank">
          <h6 class="name text-grey-darkest font-bold text-base">{{ mapLabel['name'] }}</h6>
          <div v-if="hotel.hotelNameEN && selectedLang !== 'en'" class="text-sm text-grey-darkest font-bold">{{ hotel.hotelNameEN }}</div>
        </router-link>
        <!-- <a v-else-if="hotel.type === CARD_TYPE_EXPERIENCE" :href="`https://www.owlting.com/experiences/products/${hotel.externalData}`" class="mapCard__link" target="_blank">
          <h6 class="text-grey-darkest font-bold">{{ mapLabel['name'] }}</h6>
        </a> -->
        <div class="flex items-center justify-between text-base">
          <div class="location text-xs text-grey-dark" style="min-width: 0">
            <span v-if="hotel.placesText">{{ hotel.placesText }}</span>
            <span v-if="hotel.hotelType && hotel.hotelType.name !== 'unknown'" :class="{ 'border-l-1 border-grey-dark mx-8 px-8': hotel.placesText }">{{ hotel.hotelType.name }}</span>
          </div>
          <div v-if="!hotel.inStock" class="flex items-center font-bold text-red-dark text-base flex-no-shrink whitespace-no-wrap">
            <div>{{ $t('soldOut') }}</div>
          </div>
          <div v-else-if="hotel.currency && hotel.price && Number(hotel.price) > 0" class="font-bold text-grey-darkest flex-no-shrink whitespace-no-wrap">
            <div>{{ currencySign }} {{ Number(hotel.price) | currencyConvert({inputCurrency: hotel.currency, listInteger: true}) }}</div>
          </div>
          <!-- <div v-if="hotel.tripadvisor" class="flex items-center">
            <img width="100px" :src="hotel.tripadvisor.logo" />
          </div>
          <div v-if="hotel.ranking" class="flex items-center">
            <i class="text-orange-light owl-rank-star mr-4"></i>
            <span>{{ hotel.ranking }}</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

const CARD_TYPE_EXPERIENCE = 'experience'
const CARD_TYPE_HOTEL = 'hotel'

export default {
  name: 'mapCard',
  props: {
    hotel: {
      type: Object
    }
  },
  data () {
    return {
      CARD_TYPE_EXPERIENCE,
      CARD_TYPE_HOTEL,
      cid: this._uid,
      options: {
        loop: false,
        preventInteractionOnTransition: true,
        slideToClickedSlide: false,
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 4,
        observer: true,
        observeParents: true,
        swiperButtonShow: false,
        navigation: {
          nextEl: `.swiper-button-next-${this._uid}`,
          prevEl: `.swiper-button-prev-${this._uid}`
        }
      },
      isFavorite: false,
      isSaving: false
    }
  },
  computed: {
    ...mapGetters({
      selectedLang: 'user/selectedLang',
      currencySign: 'user/currencySign',
      initWidth: 'initWidth',
      isLogin: 'user/isLogin'
    }),
    mapCardImageWidth: function () {
      return 300
    },
    hotelUuid: function () {
      switch (this.hotel.type) {
        case CARD_TYPE_EXPERIENCE:
          return this.hotel.id
        case CARD_TYPE_HOTEL:
          return this.hotel.hotelUUID
      }
      return null
    },
    hotelCover: function () {
      if (this.hotel.imageUrls.length) {
        return this.hotel.imageUrls
      } else {
        const image = require('@/assets/images/default-room.jpg')
        return [ image ]
      }
      // return require('@/assets/images/default-room.jpg')
    },
    mapLabel: function () {
      const cardType = this.hotel.type

      switch (cardType) {
        case CARD_TYPE_EXPERIENCE:
          return {
            fontColor: 'text-orange-dark',
            name: this.hotel.languageData.name
          }
        case CARD_TYPE_HOTEL:
          return {
            fontColor: 'text-blue',
            name: this.hotel.hotelNameLocal
          }
      }
      return {}
    },
    goToHotel: function () {
      return {
        name: 'HotelDetail',
        params: { hotelId: this.hotel.hotelUUID },
        query: {
          ...this.$route.query,
          externalId: this.hotel.hotelUUID,
          searchId: this.hotel.hotelUUID,
          search: this.hotel.hotelName,
          searchType: 'hotel'
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'user/addFavorite',
      'user/removeFavorite'
    ]),
    ...mapMutations([
      'hotels/SET_TARGET_HOTEL',
      'hotels/SET_THIS_HOTEL_FAVORITE'
    ]),
    close () {
      this.$emit('close-handler')
    },
    onFavoriteHandler: function (hotel) {
      this.isSaving = true
      this.isFavorite ? this.removeFavorite(hotel) : this.addFavorite(hotel)
      if (this.isLogin) {
        this.isFavorite = !this.isFavorite
      }
    },
    addFavorite: function (hotel) {
      this['user/addFavorite'](hotel.hotelUUID)
        .then(res => {
          if (res) {
            this['hotels/SET_TARGET_HOTEL']({
              ...hotel,
              isFavorite: true
            })
            this['hotels/SET_THIS_HOTEL_FAVORITE']({
              hotelUUID: hotel.hotelUUID,
              status: true
            })
            this.$message({
              message: this.$t('addItemToFavorite', [hotel.hotelNameLocal || hotel.hotelNameEN]),
              type: 'success'
            })
          }
          this.isSaving = false
        })
    },
    removeFavorite: function (hotel) {
      this['user/removeFavorite'](hotel.hotelUUID)
        .then(res => {
          if (res) {
            this['hotels/SET_TARGET_HOTEL']({
              ...hotel,
              isFavorite: false
            })
            this['hotels/SET_THIS_HOTEL_FAVORITE']({
              hotelUUID: hotel.hotelUUID,
              status: false
            })
            this.$message({
              message: this.$t('removeItemFromFavorite', [hotel.hotelNameLocal || hotel.hotelNameEN]),
              type: 'warning'
            })
          }
          this.isSaving = false
        })
    }
  },
  created () {
    this.isFavorite = this.hotel.isFavorite
  },
  mounted () {
    const swiperRef = this.$refs[`swiper-${this.cid}`]
    const sw = swiperRef && swiperRef.swiper
    const { prevBtn, nextBtn } = this.$refs
    if (sw && prevBtn && nextBtn) {
      sw.params.navigation.prevEl = prevBtn
      sw.params.navigation.nextEl = nextBtn
      sw.navigation.destroy()
      sw.navigation.init()
      sw.navigation.update()
    }
  }
}
</script>

<style lang="sass">
@import '@/assets/style/_mixins.sass'
.mapCard
  &__link
    @apply mb-4 mt-8
    text-decoration: none
    .name
      @include ellipsis(2)
    &:hover
      text-decoration: underline
      text-decoration-color: #3c4145
  .coverImage
    // padding-top: imageRatio(294, 150)
    // @apply bg-center bg-cover relative
    // background-color: #f7f7f7
    &:hover
      .swiper-button-prev, .swiper-button-next
        opacity: 1
        pointer-events: auto
  .swiper-slide
    @apply w-auto
    width: 300px
    height: 200px
    // &:not(:first-child)
    //   @apply ml-4
    .swiper-button-prev, .swiper-button-next
    @apply h-full outline-none mt-0 pin-t #{!important} flex
    width: 50px
    background-image: none !important
    z-index: 8
    .swiper-button
      @apply outline-none #{!important} rounded-full bg-grey-lightest absolute
      top: 50% !important
      transform: translateY(-50%) !important
      width: 35px !important
      height: 35px !important
      i[class*=owl-direction]
        @apply text-grey-darkest
        font-size: 18px
  .image
    @apply h-full
    padding-top: imageRatio(300, 200)
    background:
      position: center
      repeat: no-repeat
      size: cover
  .option
    transition: all .2s linear
    background-color: rgba(0, 0, 0, 0.2)
    &:hover
      background-color: rgba(0, 0, 0, 0.6)
  .swiper-button-prev
    @apply justify-center text-white
    @apply hidden rounded-full
    left: 12px !important
    width: 32px !important
    height: 32px !important
    // background: transparent !important
    background: rgba(0, 0, 0, 0.2)
    // @screen sm
    //   left: -17.5px !important
    @screen md
      @apply flex
      opacity: 0
      pointer-events: none
  .swiper-button-next
    @apply justify-center text-white
    @apply hidden rounded-full
    right: 12px !important
    width: 32px !important
    height: 32px !important
    // background: transparent !important
    background: rgba(0, 0, 0, 0.2)
    // @screen sm
    //   right: -17.5px !important
    @screen md
      @apply flex
      opacity: 0
      pointer-events: none
  .swiper-button-disabled
    @apply cursor-not-allowed
</style>
